import { useEffect, useState } from 'react';
import {
  Control,
  UseFormRegister,
  UseFormResetField,
  UseFormSetValue,
} from 'react-hook-form';
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  HStack,
  MenuSearchBoxOption,
} from '@cdl/heartbeat-react';
import { InputForm } from './inputs/InputForm';
import { NumberForm } from './inputs/NumberForm';
import { DropdownSingleData } from './dropdown/DropdownSingleData';
import { FormValues } from '../../types/annotation-task-detail.type';
import { GeneralDataHeader } from './GeneralDataHeader';
import {
  getAllAnnotationGrid,
  getAllDataset,
} from '../../clients/annotation-task.client';
import { ClearButton } from './ClearButton';

type Props = {
  register: UseFormRegister<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  control: Control<FormValues>;
  resetField: UseFormResetField<FormValues>;
};

export const GeneralDataForm: React.FC<Props> = ({
  register,
  setValue,
  control,
  resetField,
}) => {
  const [datasetList, setDatasetList] = useState<MenuSearchBoxOption[]>([]);
  const [annotationGridList, setAnnotationGridList] = useState<
    MenuSearchBoxOption[]
  >([]);

  useEffect(() => {
    const fetchData = async () => {
      setDatasetList(await getAllDataset());
      setAnnotationGridList(await getAllAnnotationGrid());
    };
    fetchData();
  }, []);

  const handleDatasetChange = (value: string) => {
    setValue('dataset_id', value, { shouldValidate: true });
  };

  const handleAnnotationGridChange = (value: string) => {
    setValue('annotation_grid', value, { shouldValidate: true });
  };

  const clearAllData = () => {
    [
      'name',
      'description',
      'priority',
      'nb_annotations',
      'dataset_id',
      'annotation_grid',
    ].forEach((field) => resetField(field));
  };

  return (
    <Accordion defaultIndex={[0]} allowMultiple h='auto'>
      <AccordionItem bgColor='white'>
        <GeneralDataHeader control={control} />
        <AccordionPanel p='xl'>
          <InputForm register={register} name='name' />
          <InputForm register={register} name='description' />
          <HStack>
            <NumberForm
              type='priority'
              isRequired
              control={control}
              step={0.5}
              max={10}
            />
            <NumberForm
              type='nb_annotations'
              isRequired
              control={control}
              max={10}
              min={1}
            />
          </HStack>
          <DropdownSingleData
            options={datasetList}
            handleDataChange={handleDatasetChange}
            register={register}
            type='dataset_id'
            required={true}
            control={control}
          />
          <DropdownSingleData
            options={annotationGridList}
            handleDataChange={handleAnnotationGridChange}
            register={register}
            type='annotation_grid'
            required={true}
            control={control}
          />
          <ClearButton clearAllData={clearAllData} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
